import { render, staticRenderFns } from "./behavior_level.vue?vue&type=template&id=3d3b8685&scoped=true"
import script from "./behavior_level.vue?vue&type=script&lang=js"
export * from "./behavior_level.vue?vue&type=script&lang=js"
import style0 from "./behavior_level.vue?vue&type=style&index=0&id=3d3b8685&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3b8685",
  null
  
)

export default component.exports